import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=a8383a8c&scoped=true"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=a8383a8c&prod&scoped=true&lang=css"
import style1 from "./ChatLayout.vue?vue&type=style&index=1&id=a8383a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8383a8c",
  null
  
)

export default component.exports